import { Component, OnInit, Input, Optional } from '@angular/core';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms.service';
import { FormInfoService } from '../../services/dynamic-forms/form-info.service';
import { BaseInputDirective } from '../base-input.directive';
import { DynamicFormInputTypes } from '../../models/dynamic-form-input-types';
import { ErrorService } from '../../services/form-utility/error.service';
import { DynamicFormLoadDirective } from '../../directives/dynamic-form-structural.directive';

@Component({
  selector: 'app-generic-input',
  templateUrl: './generic-input.component.html',
  styleUrls: ['./generic-input.component.css'],
})
export class GenericInputComponent extends BaseInputDirective implements OnInit {
  @Input() readonly: boolean;
  @Input() employeeId: number;
  @Input() showViewSSNButton: boolean = false;
  @Input() hasSSN: boolean = false;
  @Input() placeholder: string;

  textType = DynamicFormInputTypes.text;
  dateType = DynamicFormInputTypes.date;
  numberType = DynamicFormInputTypes.number;
  checkboxType = DynamicFormInputTypes.checkbox;
  selectType = DynamicFormInputTypes.select;
  currencyType = DynamicFormInputTypes.currency;
  textAreaType = DynamicFormInputTypes.textArea;
  emailType = DynamicFormInputTypes.email;
  passwordType = DynamicFormInputTypes.password;
  toggleType = DynamicFormInputTypes.toggle;
  radioType = DynamicFormInputTypes.radio;

  constructor(
    formInfoService: FormInfoService,
    dynamicFormsService: DynamicFormsService,
    errorService: ErrorService,
    @Optional()
    dynamicFormDirective: DynamicFormLoadDirective,
  ) {
    super(formInfoService, dynamicFormsService, errorService, dynamicFormDirective);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onChanged(event: any) {
    this.change.emit(event);
  }
}
